export default __webpack_public_path__ + "static/media/twoTomoea.aa3c6bea.png";